var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(_vm.data.is,_vm._g(_vm._b({tag:"Component"},'Component',_vm.data,false),_vm.action.handlers),[_vm._v("\n\t"+_vm._s(_vm.data.text)+"\n")])}
var staticRenderFns = []

export { render, staticRenderFns }